import { defineMessage, useIntl } from 'react-intl';

import { useI18n } from '@packages/shared/src/hooks/useI18n/useI18n';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { getLocalizedPath } from '@packages/shared/src/utils/getLocalizedPath/getLocalizedPath';

const titleMessage = defineMessage({
  id: 'slot.account.label',
  defaultMessage: 'Mein Konto',
});

export const useAccountLink = () => {
  const { formatMessage } = useIntl();
  const { locale } = useI18n();
  const {
    order: {
      paths: { myAccountOverview },
    },
  } = useConfig();

  const href = getLocalizedPath(myAccountOverview, locale);
  const label = formatMessage(titleMessage);

  return {
    href,
    label,
  };
};
